import Tree from 'components/classroom/Tree';
import { Alert, Form } from 'antd';
import { IClassroom } from '../../../interfaces/classrooms';
import { ITree } from 'interfaces/tree';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

export const ClassroomContent = ({
  classroom,
  onChange
}: {
  classroom: IClassroom;
  onChange?: (data: ITree) => void;
}) => {
  const [contentTree, setContentTree] = useState<ITree>(classroom.content_tree);

  const onUpdateTree = (data: ITree) => {
    setContentTree(data);
    onChange?.(data);
  };

  return (
    <>
      <Alert
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message="Somente conteúdos dentro de uma seção aparecem para o aluno. Para disponibilizar um item, mova-o para uma seção."
        className="mb-4 border-primary-100 bg-primary-50 text-neutral-700 [&_.ant-alert-icon]:text-primary-500"
      />
      <Form.Item name={['content_tree']}>
        <Tree
          tree={contentTree}
          onUpdate={onUpdateTree}
          classroom={classroom}
        />
      </Form.Item>
    </>
  );
};
